import { render, staticRenderFns } from "./PatientFrictionPage.vue?vue&type=template&id=4da0f631&scoped=true"
import script from "./PatientFrictionPage.vue?vue&type=script&lang=js"
export * from "./PatientFrictionPage.vue?vue&type=script&lang=js"
import style0 from "./PatientFrictionPage.vue?vue&type=style&index=0&id=4da0f631&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da0f631",
  null
  
)

export default component.exports